import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MonitorImage from './MonitorImage';

class ImagesMonitor extends Component {
  state = {
    images: [],
    updateImages: [],
  };

  // TODO Should be tested if/when this will be used
  constructor(props) {
    super(props);

    this.submitUpdateImages = this.submitUpdateImages.bind(this);
    this.changeContent = this.changeContent.bind(this);
  }

  // TODO Should be tested if/when this will be used
  componenDidMount() {
    const { images } = this.props;
    const updateImages = [];

    if (images) {
      const id = 'id';

      images.forEach((image) => {
        updateImages.push({ id: image[id].$oid, content: 'approved' });
      });
    }

    this.setState({
      images,
      updateImages,
    });
  }

  // TODO Should be tested if/when this will be used
  changeContent(id, content) {
    this.setState((prevState) => {
      const updateImagesCopy = prevState.updateImages;
      for (let i = 0; i < updateImagesCopy.length; i += 1) {
        if (updateImagesCopy[i].id === id) {
          updateImagesCopy[i].content = content;
          break;
        }
      }

      return { updateImages: updateImagesCopy };
    });
  }

  submitUpdateImages() {
    const { save } = this.props;
    const { updateImages } = this.state;
    save(updateImages);
  }

  render() {
    const {
      saving,
      imageUrlBase,
      imagePreviewUrlBase,
    } = this.props;
    const { images } = this.state;
    const content = [];
    const id = 'id';

    let savingBtn = (
      <button
        type="button"
        className="btn btn--b mtl admin-monitorSubmit-btn"
        onClick={this.submitUpdateImages}
      >
        Save
      </button>
    );

    if (saving) {
      savingBtn = (
        <button
          type="button"
          className="btn btn--b mtl admin-monitorSubmit-btn"
          disabled
        >
          Saving ...
        </button>
      );
    }

    if (images.length > 0) {
      images.forEach((image, index) => {
        if (image.filename) {
          const keyBase = 'monitor_image_';
          const key = keyBase + index;
          const readyContent = (
            <MonitorImage
              filename={image.filename}
              imageId={image[id].$oid}
              key={key}
              changeContent={this.changeContent}
              imageUrlBase={imageUrlBase}
              imagePreviewUrlBase={imagePreviewUrlBase}
            />
          );
          content.push(readyContent);
        }
      });
    }

    return (
      <div>
        {content}
        <br />
        {savingBtn}
      </div>
    );
  }
}

ImagesMonitor.propTypes = {
  images: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  save: PropTypes.func.isRequired,
  imageUrlBase: PropTypes.string.isRequired,
  imagePreviewUrlBase: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
};

ImagesMonitor.defaultProps = {
  images: [],
};

export default ImagesMonitor;
